import { Box, Typography, Paper } from "@mui/material";
import { CheckCircle, Cancel } from "@mui/icons-material";

const CertificateStatusCard = ({ status, data, message }) => {
  const isValid = status === "VALID";

  return (
    <Paper
      sx={{
        maxWidth: 500,
        width: "100%",
        p: 3,
        textAlign: "center"
      }}
    >
      {isValid ? (
        <CheckCircle color="success" sx={{ fontSize: 60 }} />
      ) : (
        <Cancel color="error" sx={{ fontSize: 60 }} />
      )}

      <Typography
        variant="h6"
        fontWeight="bold"
        mt={2}
        color={isValid ? "green" : "error"}
      >
        {isValid ? "Certificate Verified" : "Invalid Certificate"}
      </Typography>

      {isValid ? (
        <Box mt={2} textAlign="left">
          <Info label="Certificate No" value={data.certificateNumber} />
          <Info label="Employee Name" value={data.employeeName} />
          <Info label="Designation" value={data.designation} />
          <Info label="Department" value={data.department} />
          <Info label="Certificate Type" value={data?.type ?? "Experience"} />
          <Info label="Issued By" value={data.fromDate} />
          <Info label="Issue Date" value={data.issueDate} />
        </Box>
      ) : (
        <Typography mt={2}>{message}</Typography>
      )}

      <Typography
        variant="caption"
        display="block"
        mt={3}
        textAlign="center"
      >
        This verification page confirms the authenticity of the certificate.
      </Typography>
    </Paper>
  );
};

const Info = ({ label, value }) => (
  <Box display="flex" justifyContent="space-between" my={0.5}>
    <Typography fontWeight="bold">{label}</Typography>
    <Typography>{value}</Typography>
  </Box>
);

export default CertificateStatusCard;
